import React from "react";
import use123zapStore from "../../../context/123zapStore";
import { GetListagens } from "../../../services/api/Listagens/GetListagens";
import { truncateText } from "../../../shared/utils/utils";
import { useAuth } from "../../../app/providers/AuthProvider";

export function useSheets() {
  const { isAuthenticated } = useAuth();

  const sheets = use123zapStore((state) => state.sheets);
  const setSheets = use123zapStore((state) => state.setSheets);

  const alreadyFetchSheets = use123zapStore(
    (state) => state.alreadyFetchSheets,
  );
  const setAlreadyFetchSheets = use123zapStore(
    (state) => state.setAlreadyFetchSheets,
  );

  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState(null);

  const fetchListagens = React.useCallback(async () => {
    try {
      setLoading(true);
      setError(null);

      const resultJson = await GetListagens();

      const listagens = (resultJson?.data || []).map((item) => ({
        id: item.code,
        title: item.title,
        description: item.description,
        desc: truncateText(item.description, 50),
        link: item.url,
        type: item.type,
        icon: item.type,
      }));

      setSheets(listagens);
      setAlreadyFetchSheets(true);
    } catch (err) {
      console.error(err);
      setError(err);
    } finally {
      setLoading(false);
    }
  }, [setSheets, setAlreadyFetchSheets]);

  React.useEffect(() => {
    if (!isAuthenticated || alreadyFetchSheets) return;

    fetchListagens();
  }, [isAuthenticated, alreadyFetchSheets, fetchListagens]);

  return {
    rows: sheets,
    loading,
    error,
    refetch: fetchListagens,
  };
}